/*
 * The unauthenticated frame for the login and forced-reset screens: a single centred card on the
 * app background, with no side nav (the operator has no session to navigate yet). Kept separate from
 * the authenticated PageShell frame so these screens never render a nav rail.
 */
import type { ReactNode } from 'react';

export function AuthLayout({ children }: { readonly children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4 py-10">
      <div className="w-full max-w-[380px]">{children}</div>
    </main>
  );
}
